// config/tableConfigs/platformUserConfig.js
// Matches your exact tableConfigs shape (MemberManagement pattern)

export const PlatformUserManagement = {
  title: "Platform User Management",
  breadcrumbIcon: "ph-duotone ph-user-gear",
  breadcrumbParent: "Settings",
  showDateFilter: false,
  idField: "id",
  defaultItemsPerPage: 10,
  defaultSortField: "created_at",
  defaultSortDirection: "desc",
  numericFields: [],

  columns: [
    {
      key: "id",
      label: "#",
      type: "text",
      sortable: false,
    },
    {
      key: "name",
      label: "Name",
      type: "text",
      sortable: true,
      className: "f-w-500 text-dark",
    },
    {
      key: "phone",
      label: "Phone",
      type: "text",
      className: "f-w-500 text-dark",
    },
    {
      key: "email",
      label: "Email",
      type: "text",
      className: "text-muted",
    },
    {
      key: "scope",
      label: "Scope",
      type: "badge",
      badgeClass: (value) => {
        const map = {
          "All companies":       "badge text-outline-primary",
          "Admin's companies":   "badge text-outline-info",
          "White Label only":    "badge text-outline-secondary",
        };
        return map[value] || "badge text-outline-secondary";
      },
    },
    {
      key: "modules",
      label: "Modules",
      type: "custom", // rendered manually in page
    },
    {
      key: "is_active",
      label: "Status",
      type: "badge",
      badgeClass: (value) =>
        value ? "badge text-outline-success" : "badge text-outline-danger",
      transform: (value) => (value ? "Active" : "Inactive"),
    },
    {
      key: "created_at",
      label: "Created On",
      type: "text",
      sortable: true,
    },
  ],

  filters: [
    {
      key: "is_active",
      label: "Status",
      width: "140px",
      options: [
        { label: "All", value: "" },
        { label: "Active", value: "true" },
        { label: "Inactive", value: "false" },
      ],
    },
  ],

  actions: {
    edit: true,
    delete: true, // used for deactivate
  },
};

// ── Module definitions (used in form + badge rendering) ────────────────────

export const PLATFORM_MODULES = [
  {
    key:         "can_report",
    label:       "Reports",
    icon:        "ph-duotone ph-chart-bar",
    badgeClass:  "badge text-outline-info",
    description: "View & export all reports",
    restrictedFor: [],
  },
  {
    key:         "can_credit",
    label:       "Credit",
    icon:        "ph-duotone ph-plus-circle",
    badgeClass:  "badge text-outline-success",
    description: "Add credit to wallets",
    restrictedFor: ["White label"],
  },
  {
    key:         "can_debit",
    label:       "Debit",
    icon:        "ph-duotone ph-minus-circle",
    badgeClass:  "badge text-outline-danger",
    description: "Debit wallets (needs approval)",
    restrictedFor: ["White label"],
  },
  {
    key:         "can_member_view",
    label:       "View Members",
    icon:        "ph-duotone ph-users",
    badgeClass:  "badge text-outline-warning",
    description: "View member profiles",
    restrictedFor: [],
  },
  {
    key:         "can_member_edit",
    label:       "Edit Members",
    icon:        "ph-duotone ph-user-gear",
    badgeClass:  "badge text-outline-secondary",
    description: "Edit member profiles",
    restrictedFor: [],
  },
];

// Returns modules the current role is allowed to grant
export const getAllowedModules = (role) =>
  PLATFORM_MODULES.filter((m) => !m.restrictedFor.includes(role));

// Roles that can manage platform users
export const PLATFORM_MANAGER_ROLES = ["Main Admin", "Admin", "White label"];